import { NumberInput, useTranslate } from "react-admin";

export const RaNumberInput = ({ label, source, ...props }) => {
    const translate = useTranslate();

    return (
        <NumberInput
            label={label || `equip.${source}`}
            source={source}
            title={translate(label || `equip.${source}`)}
            {...props}
        />
    );
};
